<div class="dashboard-banner" *ngIf="showIS4UPSBanner">
  <div class="banner">
    <div class="banner-contents">
      <div class="banner-section">
        <div class="header-logo"><img src="../../../../assets/images/multicarrier/Logos.png"></div>
        <div class="banner-head">Expand Your Coverage with Multi-Carrier Insurance</div>
        <div class="banner-desc">Get broader protection and more flexibility across your shipments with multi-carrier
          coverage.</div>
        <button class="upsc-button" (click)="gotoCarrier()">
          <div class="btn-text-icon">
            <div class="text">
              Explore Coverage</div><mat-icon>chevron_right</mat-icon>
          </div>
        </button>
      </div>

    </div>
    <div class="img-group">
      <img src="../../../assets/images/multicarrier/Frame_24005.png">
      <img src="../../../assets/images/close.png" class="close">
    </div>

  </div>
</div>
<!-- assets/images/multicarrier/Frame_24005.png -->